// eslint-disable-next-line import/extensions
import { SelectSlot } from 'node_modules/@chakra-ui/react/dist/types/styled-system/generated/recipes.gen';
import { CSSObjectWithLabel, StylesConfig } from 'react-select';
import { SystemStyleObject } from '@chakra-ui/react';

import {
  ControlledSelectGroup,
  ControlledSelectOption,
} from '../../../types/ControlledSelectOption';

export const getReactSelectStylesOverrides = (
  {
    control,
    content,
    indicatorGroup,
    indicator,
    trigger,
    itemGroup,
    itemGroupLabel,
    item,
    itemText,
    list,
    valueText,
  }: Record<SelectSlot, SystemStyleObject>,
  input: SystemStyleObject,
): StylesConfig<ControlledSelectOption, boolean, ControlledSelectGroup> => ({
  dropdownIndicator: (base) =>
    ({
      ...base,
      ...indicatorGroup,
      position: 'unset',
    }) as CSSObjectWithLabel,
  container: (base) =>
    ({
      ...base,
      ...control,
    }) as CSSObjectWithLabel,
  control: (base) =>
    ({
      ...base,
      ...input,
      height: 'auto',
    }) as CSSObjectWithLabel,
  menuPortal: (base) => ({
    ...base,
    minWidth: 300,
    // 1 above the Chakra popover zIndex (1500) to ensure the menu appears above the dialog
    zIndex: 1501,
    // if we're inside a modal, anything attached to the body has pointerEvents disabled, so we need to re-enable it for the menu
    pointerEvents: 'all',
  }),
  menu: (base) =>
    ({
      ...base,
      ...content,
    }) as CSSObjectWithLabel,
  placeholder: (base) =>
    ({
      ...base,
      ...valueText,
    }) as CSSObjectWithLabel,
  valueContainer: (base) =>
    ({
      ...base,
      position: 'relative',
      overflow: 'hidden',
    }) as CSSObjectWithLabel,
  singleValue: (base) =>
    ({
      ...base,
      ...valueText,
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      maxWidth: 'calc(100% - 8px)',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    }) as CSSObjectWithLabel,
  menuList: (base) =>
    ({
      ...base,
      ...list,
    }) as CSSObjectWithLabel,
  group: (base) =>
    ({
      ...base,
      ...itemGroup,
    }) as CSSObjectWithLabel,
  groupHeading: (base) =>
    ({
      ...base,
      ...itemGroupLabel,
    }) as CSSObjectWithLabel,
  option: (base, { isFocused, isSelected }) =>
    ({
      ...base,
      ...item,
    }) as CSSObjectWithLabel,
});
